export const findDuplicate = <T>(elems: T[], getId: (elem: T) => string): T | null => {
  const seenIds = new Set<string>([]);
  for (const elem of elems) {
    const id = getId(elem);
    if (seenIds.has(id)) return elem;
    seenIds.add(id);
  }

  return null;
};

export default findDuplicate;
